import React, { useState } from 'react';
import { Eye, EyeOff, Copy, Check } from 'lucide-react';

// Masks a license-key identifier in list/log views: shows a masked form (prefix +
// last chars) with click-to-reveal + copy. The key is an identifier, not a secret;
// this is shoulder-surf/screenshot hygiene, not access control.
/** The masked form MaskedKey shows: prefix + last five characters. A short value is fully masked. */
export function maskKeyValue(value: string): string {
  return value.length > 10 ? `${value.slice(0, 3)}…${value.slice(-5)}` : '••••';
}

export function MaskedKey({ value, size = 12 }: { value?: string | null; size?: number }) {
  const [shown, setShown] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!value) return <span style={{ color: 'var(--text-muted)' }}>—</span>;
  const masked = maskKeyValue(value);
  const copy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontFamily: 'var(--mono, monospace)', fontSize: size }}>
      {/* ps-no-capture: rrweb blockClass. The revealed state puts the raw key in
          the DOM, and the reporter's "include visible text" posture drops the
          global text mask — so this node is fenced unconditionally rather than
          on `shown`, which would leave a race between the class landing and the
          text mutation. Smallest node that holds the value. */}
      <span className="ps-no-capture" style={{ letterSpacing: shown ? 0 : '.5px' }}>{shown ? value : masked}</span>
      <button onClick={(e) => { e.stopPropagation(); setShown((s) => !s); }} title={shown ? 'Hide' : 'Reveal'} style={btn}>{shown ? <EyeOff size={13} /> : <Eye size={13} />}</button>
      <button onClick={copy} title="Copy" style={btn}>{copied ? <Check size={13} color="#16A34A" /> : <Copy size={13} />}</button>
    </span>
  );
}
const btn: React.CSSProperties = { display: 'inline-flex', alignItems: 'center', background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'var(--text-muted)' };
